import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Box, Typography, List, ListItem, ListItemIcon } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const requirements = [
    'Minimum 8 characters',
    'At least one uppercase letter',
    'At least one number',
    'At least one special character',
];

const PasswordRequirements = () => {
    return (
        <Box
            sx={{
                backgroundColor: 'grey.50',
                borderRadius: 2,
                p: 3,
                boxShadow: 1,
            }}
        >
            {/* Header Section */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <AlertCircle size={20} style={{ color: '#3b82f6', marginRight: 8 }} />
                <Typography variant="subtitle1" fontWeight="medium">
                    Password Requirements
                </Typography>
            </Box>

            {/* Requirements List */}
            <List sx={{ pl: 1 }}>
                {requirements.map((requirement, index) => (
                    <ListItem key={index} disableGutters>
                        <ListItemIcon sx={{ minWidth: 24 }}>
                            <CircleIcon sx={{ fontSize: 8, color: 'green' }} />
                        </ListItemIcon>
                        <Typography variant="body2" color="text.secondary">
                            {requirement}
                        </Typography>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default PasswordRequirements;
